import { z } from 'zod';

/** Mirrors apps/api/src/modules/order/http/order.dto.ts's `updateOrderStatusSchema` exactly. */
export const updateOrderStatusFormSchema = z.object({
  status: z.enum(['PROCESSING', 'PACKED', 'CANCELLED']),
  reason: z.string().trim().max(500).optional(),
});
export type UpdateOrderStatusFormValues = z.infer<typeof updateOrderStatusFormSchema>;
